// extracted by mini-css-extract-plugin
module.exports = {"typeformIframe":"styles-module--typeform-iframe--1H715"};